var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uw-page',{attrs:{"title":"合同附件"}},[_c('template',{slot:"header-suffix"},[_c('contract-button-files-upload',{attrs:{"contract_id":_vm.contract.id},on:{"onChange":_vm.Search}})],1),_c('files-table',{model:{value:(_vm.contract.files_id),callback:function ($$v) {_vm.$set(_vm.contract, "files_id", $$v)},expression:"contract.files_id"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }